import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { WifiIcon, WifiOffIcon, ActivityIcon, AlertCircleIcon } from 'lucide-react';
const deviceStatusData = [{
  name: 'Online',
  value: 95,
  color: '#8DB43E'
}, {
  name: 'Offline',
  value: 3,
  color: '#E07020'
}, {
  name: 'Warning',
  value: 2,
  color: '#EAB308'
}];
const diagnosticLogs = [{
  time: '10:45 AM',
  device: 'MTR-8923',
  type: 'Connection Lost',
  severity: 'High',
  message: 'Device stopped responding to ping.'
}, {
  time: '10:42 AM',
  device: 'MTR-1124',
  type: 'High Latency',
  severity: 'Medium',
  message: 'Response time > 500ms.'
}, {
  time: '10:30 AM',
  device: 'GTW-005',
  type: 'Firmware Update',
  severity: 'Info',
  message: 'Update completed successfully.'
}, {
  time: '10:15 AM',
  device: 'MTR-4451',
  type: 'Tamper Alert',
  severity: 'Critical',
  message: 'Meter cover removed.'
}, {
  time: '09:55 AM',
  device: 'MTR-8923',
  type: 'Signal Weak',
  severity: 'Medium',
  message: 'RSSI below threshold.'
}];
export function NetworkDiagnostics() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-1620">
      <div className="mb-8" data-id="element-1621">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1622">
          Network Diagnostics
        </h1>
        <p className="text-gray-500" data-id="element-1623">
          Monitor connectivity and health of smart meters and network devices.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-1624">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1625">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1626">
            <WifiIcon className="w-5 h-5" data-id="element-1627" />
          </div>
          <div data-id="element-1628">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1629">
              Connected Devices
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1630">124,500</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1631">
          <div className="p-3 bg-red-50 text-red-600 rounded-none" data-id="element-1632">
            <WifiOffIcon className="w-5 h-5" data-id="element-1633" />
          </div>
          <div data-id="element-1634">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1635">
              Offline Meters
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1636">1,230</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1637">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-1638">
            <ActivityIcon className="w-5 h-5" data-id="element-1639" />
          </div>
          <div data-id="element-1640">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1641">
              Avg Latency
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1642">45ms</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1643">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-1644">
            <AlertCircleIcon className="w-5 h-5" data-id="element-1645" />
          </div>
          <div data-id="element-1646">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1647">
              Packet Loss
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1648">0.2%</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8" data-id="element-1649">
        <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200 lg:col-span-1" data-id="element-1650">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1651">
            Device Status
          </h2>
          <div className="h-64" data-id="element-1652">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1653">
              <PieChart data-id="element-1654">
                <Pie data={deviceStatusData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1655">

                  {deviceStatusData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1656" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} formatter={(value: number) => [`${value}%`, 'Status']} data-id="element-1657" />

                <Legend verticalAlign="bottom" height={36} data-id="element-1658" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden lg:col-span-2" data-id="element-1659">
          <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-1660">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-1661">Diagnostic Logs</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-1662">
            <table className="w-full text-left border-collapse" data-id="element-1663">
              <thead data-id="element-1664">
                <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-1665">
                  <th className="p-4 font-medium" data-id="element-1666">Timestamp</th>
                  <th className="p-4 font-medium" data-id="element-1667">Device ID</th>
                  <th className="p-4 font-medium" data-id="element-1668">Event Type</th>
                  <th className="p-4 font-medium" data-id="element-1669">Severity</th>
                  <th className="p-4 font-medium" data-id="element-1670">Message</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-1671">
                {diagnosticLogs.map((log, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-1672">
                    <td className="p-4 text-sm text-gray-500 whitespace-nowrap" data-id="element-1673">
                      {log.time}
                    </td>
                    <td className="p-4 text-sm font-mono text-gray-900" data-id="element-1674">
                      {log.device}
                    </td>
                    <td className="p-4 text-sm font-medium text-gray-900" data-id="element-1675">
                      {log.type}
                    </td>
                    <td className="p-4" data-id="element-1676">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${log.severity === 'Critical' ? 'bg-red-100 text-red-800' : log.severity === 'High' ? 'bg-orange-100 text-orange-800' : log.severity === 'Medium' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1677">

                        {log.severity}
                      </span>
                    </td>
                    <td className="p-4 text-sm text-gray-600" data-id="element-1678">{log.message}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}